export const ActionTypes = {
    FETCH_AVAILABLE_AREAS_REQUEST: "FETCH_AVAILABLE_AREAS_REQUEST",
    FETCH_AVAILABLE_AREAS_SUCCESS: "FETCH_AVAILABLE_AREAS_SUCCESS",
    FETCH_AVAILABLE_AREAS_FAILURE: "FETCH_AVAILABLE_AREAS_FAILURE",
}
